export const consentStorageKey = "pimp-my-place-analytics-consent";
export const consentVersion = 3;
const consentDuration = 365 * 24 * 60 * 60 * 1000;

const parseConsent = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const readConsentStorage = () => {
  try {
    return window.localStorage.getItem(consentStorageKey);
  } catch {
    return null;
  }
};

export const getStoredConsent = () => {
  const consent = parseConsent(readConsentStorage());
  const hasValidValue = consent?.value === "granted" || consent?.value === "denied";
  const hasValidTimestamp = typeof consent?.timestamp === "number";
  const isCurrent = hasValidValue && hasValidTimestamp && consent.version === consentVersion && Date.now() - consent.timestamp < consentDuration;
  return isCurrent ? consent.value : null;
};

export const updateAnalyticsConsent = (granted) => {
  if (granted) {
    window.loadGa4?.();
  }
  window.gtag?.("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
};

export const saveAnalyticsConsent = (granted) => {
  try {
    window.localStorage.setItem(consentStorageKey, JSON.stringify({ value: granted ? "granted" : "denied", timestamp: Date.now(), version: consentVersion }));
  } catch {
    // Consent remains active for the current session when browser storage is unavailable.
  }
  updateAnalyticsConsent(granted);
  window.dispatchEvent(new CustomEvent("pimp-consent-updated", { detail: { granted } }));
};

export const trackPageView = () => {
  window.gtag?.("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
};

export const trackEstimateConversion = () => {
  // Envoi direct « force brute » vers GA4 (sans gtag ni Consent Mode) :
  // aucun cookie déposé, identifiant aléatoire non traçable — méthode validée
  // par le diagnostic test_direct_neo du 13/08.
  const params = new URLSearchParams({
    v: "2",
    tid: "G-96LFDYNBFS",
    cid: `${Date.now()}.${Math.floor(Math.random() * 1e9)}`,
    sid: String(Math.floor(Date.now() / 1000)),
    sct: "1",
    seg: "1",
    _p: String(Math.floor(Math.random() * 1e9)),
    dl: window.location.href,
    dt: document.title,
    en: "generate_lead",
    "epn.value": "1",
    cur: "EUR",
    "ep.event_category": "estimation",
    "ep.event_label": "formulaire_estimation",
    _ee: "1",
  });
  navigator.sendBeacon(`https://www.google-analytics.com/g/collect?${params.toString()}`);
};

export const trackCardAction = (action, agentSlug) => {
  window.gtag?.("event", "card_action", {
    event_category: "carte_digitale",
    event_label: action,
    agent: agentSlug,
  });
};

export const trackContactClick = (channel, location) => {
  window.gtag?.("event", "contact_click", {
    event_category: "contact",
    channel,
    click_location: location,
  });
};